import React from 'react';
import { createPortal } from 'react-dom';
import { LogOut, AlertTriangle, X } from 'lucide-react';

interface LogoutConfirmDialogProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const LogoutConfirmDialog: React.FC<LogoutConfirmDialogProps> = ({
  isOpen,
  onConfirm,
  onCancel,
}) => {
  if (!isOpen) return null;

  return createPortal(
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-navy/30 backdrop-blur-md animate-in fade-in duration-300">
      <div className="bg-surface-container-lowest/80 backdrop-blur-md shadow-ambient rounded-3xl w-full max-w-sm border border-outline-variant/10 overflow-hidden flex flex-col scale-in animate-in zoom-in-95 duration-200">
        
        {/* Header */}
        <header className="px-6 py-5 flex items-center justify-between">
          <div className="w-10 h-10 rounded-xl bg-error/5 flex items-center justify-center text-error">
            <AlertTriangle size={20} />
          </div>
          <button onClick={onCancel} className="p-1 hover:bg-surface-container rounded-lg transition-colors">
            <X size={18} className="text-secondary" />
          </button>
        </header>

        {/* Content */}
        <div className="px-6 pb-6 space-y-2">
          <h3 className="text-lg font-bold font-display text-navy">Sign out?</h3>
          <p className="text-xs text-secondary leading-relaxed">
            Logging out will delete all temporary data and chat history at the agent level. 
            <span className="block mt-2 font-bold text-navy">
              Reports saved in the Data Utility will remain preserved.
            </span>
          </p>
        </div>

        {/* Footer */}
        <footer className="px-6 py-4 bg-surface-container-low flex items-center gap-3 border-t border-surface-variant/10">
          <button 
            onClick={onCancel}
            className="flex-1 py-2.5 text-xs font-bold text-secondary hover:bg-surface-variant/10 rounded-xl transition-colors"
          >
            Stay Signed In
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 py-2.5 bg-error text-white text-xs font-bold rounded-xl shadow-button hover:bg-error-dark transition-all flex items-center justify-center gap-2"
          >
            <LogOut size={14} />
            Log Out
          </button>
        </footer>
      </div>
    </div>,
    document.body
  );
};
